import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { AdminSidebarV2, DashboardContainerV2 } from '@saucelabs/sl-container-dashboard';
import { NotFound } from '@saucelabs/sl-component-error-pages';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import { isSupportedFeature, constants as features } from '@saucelabs/sl-component-supported-feature';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import jobsReducer from '../reducers';
import * as operations from './../ducks/users/operations';
import FlatBuildsContainerWrapper from './FlatBuildsContainerWrapper';
import FlatHeadlessJobsContainerWrapper from './FlatHeadlessJobsContainerWrapper';
import FlatJobsContainerWrapper from './FlatJobsContainerWrapper';
import FlatManualJobsContainerWrapper from './FlatManualJobsContainerWrapper';

const AdminUserDashboardContainer = ({
  location,
  putSubaccountUserInStore,
  sidebarCollapsed,
  ...props
}) => {
  const { match: { params: { username }, url } } = props;
  putSubaccountUserInStore({ username });

  const containerProps = {
    SidebarContent: (
      <AdminSidebarV2
        location={location}
        sidebarCollapsed={sidebarCollapsed}
        username={username}
      />
    ),
    viewName: 'Admin User\'s Dashboard',
  };

  return (
    <DashboardContainerV2 {...containerProps} >
      <LoginRequiredContainer>
        <Switch>
          <Route
            component={() => (
              <FlatBuildsContainerWrapper
                {...props}
                isSubaccountDashboard
                username={username}
              />
            )}
            path={`${url}/dashboard/builds`}
          />
          {isSupportedFeature(features.DASHBOARD_TAB_AUTOMATED_BUILDS) ? (
            <Route
              component={() => (
                <FlatJobsContainerWrapper
                  {...props}
                  isSubaccountDashboard
                  username={username}
                />
              )}
              path={`${url}/dashboard/tests/:cloudType`}
            />
          ) : (
            <Route
              component={() => (
                <FlatHeadlessJobsContainerWrapper
                  {...props}
                  isSubaccountDashboard
                  username={username}
                />
              )}
              path={`${url}/dashboard/tests/:cloudType`}
            />
          )}
          {isSupportedFeature(features.LIVE_TESTING) && (
            <Route
              component={() => (
                <FlatManualJobsContainerWrapper
                  {...props}
                  isSubaccountDashboard
                  username={username}
                />
              )}
              path={`${url}/dashboard/live`}
            />
          )}
          <Redirect
            from={`${url}/dashboard`}
            to={`${url}/dashboard/builds`}
          />
          {/* Render 404 error page if there is no Route match */}
          <Route component={NotFound} />
        </Switch>
      </LoginRequiredContainer>
    </DashboardContainerV2>
  );
};

AdminUserDashboardContainer.propTypes = {
  location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  match: PropTypes.shape({
    params: PropTypes.shape({
      username: PropTypes.string.isRequired,
    }).isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  putSubaccountUserInStore: PropTypes.func.isRequired,
  sidebarCollapsed: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  sidebarCollapsed: state.user.isAuthenticated() && state.sidebar.get('collapsed'),
});

const mapDispatchToProps = {
  putSubaccountUserInStore: operations.putSubaccountUserInStore,
};

export default dynamic('apps.jobs', attachReducer(jobsReducer))(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(
      AdminUserDashboardContainer,
    ),
  ),
);

export { AdminUserDashboardContainer };
